"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMountCacheSync = exports.getMountCacheSync = exports.cache = void 0;
// Exported for testing only
exports.cache = new Map();
function getMountCacheSync(mountCacheKey) {
    return exports.cache.get(mountCacheKey);
}
exports.getMountCacheSync = getMountCacheSync;
function setMountCacheSync(mountCacheKey, mountFn) {
    exports.cache.set(mountCacheKey, mountFn);
}
exports.setMountCacheSync = setMountCacheSync;
//# sourceMappingURL=mountCache.js.map